import { CloudDeliveryPromiseType } from "@omni/types/api/product/cloud/shared/enums/deliveryPromiseType.enum";
import { CloudStockLevel } from "@omni/types/api/product/cloud/shared/enums/stockLevel.enum";
import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { determineDeliveryTimeTranslationKey } from "@/utils/deliveryPromise";

type StoreProductAvailabilityComponentProps = {
    productAvailability: CloudProductAvailability;
};

export const StoreProductAvailabilityComponent = ({
    productAvailability
}: StoreProductAvailabilityComponentProps) => {
    const { t } = useGranite();

    let className = "text-success";
    let icon = "la-check";
    const tk =
        determineDeliveryTimeTranslationKey(
            productAvailability?.deliveryPromiseType,
            productAvailability?.stockLevel,
            productAvailability?.realTimeStockAvailable,
            productAvailability?.realTimeStock
        ) || "";

    if (
        productAvailability?.deliveryPromiseType ===
        CloudDeliveryPromiseType.AvailableForS2S
    ) {
        className = "";
    } else if (
        !productAvailability?.realTimeStockAvailable &&
        productAvailability?.stockLevel === CloudStockLevel.LowStock
    ) {
        className = "text-warning";
    } else if (
        (!productAvailability?.realTimeStockAvailable &&
            productAvailability?.stockLevel === CloudStockLevel.NoStock) ||
        (!productAvailability?.realTimeStockAvailable &&
            productAvailability?.stockLevel === null) ||
        (productAvailability?.realTimeStockAvailable &&
            productAvailability?.realTimeStock! <= 0)
    ) {
        className = "text-danger";
        icon = "la-times";
    }

    const deliveryTimeUnitTk = `product.deliveryPromise.timeUnits.${productAvailability?.deliveryTimeUnit}`;

    return (
        <p className={cn(className, "tw:m-0")}>
            <i className={cn(`las ${icon}`, "tw:mr-1")} />
            {tk &&
                t(
                    tk,
                    productAvailability?.deliveryTime,
                    t(deliveryTimeUnitTk),
                    productAvailability?.realTimeStock
                )}
        </p>
    );
};
